import { getClientData } from 'src/store/client/selectors';
import { connect } from 'react-redux';
import { touristsSelector } from 'src/store/tourists/selectors';
import {
  goToClientAction,
  goToFlightSectionAction,
  goToTouristsAction,
  onClientClickAction,
  setShowSummaryAction,
} from '../../store/actions/view';
import { getShowSummary } from '../../store/selectors/view';
import {
  getEndDate,
  getInstantConfirm,
  getIsInsurable,
  getIsPrivateTransfer,
  getMeal,
  getNightsCount,
  getNightsInHotel,
  getPackageId,
  getStartDate,
  getTouristsText,
  getTransfer,
} from '../../store/selectors/package';
import {
  getOrderTouristsConfirmed,
  getOriginalPackageOrderBonuses,
  getPriceDetails,
  getRemainingPaymentAmount,
  getSelectedFlightData,
  orderOriginalTotalBonuses,
} from '../../store/selectors/order';
import {
  getCheckinFromInfo,
  getCheckoutUntilInfo,
  getHotelImageSmall,
  getHotelLocation,
  getHotelName,
  getHotelStars,
} from '../../store/selectors/hotel';
import type {
  DateSummaryInfoForHotels,
  DateSummaryInfoForTours,
} from './types';
import MobileSummaryTours from './MobileSummaryTours';
import MobileSummaryHotels from './MobileSummaryHotels';

import { isChangableFlightSelector } from '../../store/selectors/extras';
import { onTouristClickAction } from '../../store/actions/tourists';
import { openRoomPopupAction } from '../../store/domains/room-popup/actions';

const mapStateToPropsForHotels = (state) => {
  const hotelDates: DateSummaryInfoForHotels = {
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    nights: getNightsInHotel(state),
    checkInTime: getCheckinFromInfo(state),
    checkOutTime: getCheckoutUntilInfo(state),
  };

  const hotelInfo = {
    location: getHotelLocation(state),
    name: getHotelName(state),
    stars: getHotelStars(state),
    image: getHotelImageSmall(state),
    meal: getMeal(state),
  };

  return {
    totalPrice: getRemainingPaymentAmount(state),
    instantConfirm: getInstantConfirm(state),
    cashbackAmount: orderOriginalTotalBonuses(state),
    packageId: getPackageId(state),
    priceDetailsItems: getPriceDetails(state),
    cashbackIdentifier:
      getOriginalPackageOrderBonuses(state)?.cashback_identifier || undefined,

    hotel: hotelInfo,
    touristsText: getTouristsText(state),

    client: getClientData(state) || undefined,

    tourists: touristsSelector(state),
    visible: getShowSummary(state),
    isTouristsConfirmed: getOrderTouristsConfirmed(state),

    isHotelOnly: true as const,
    dates: hotelDates,
  };
};

const mapStateToPropsForTours = (state) => {
  const tourDates: DateSummaryInfoForTours = {
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    nights: getNightsInHotel(state),
    originalNights: getNightsCount(state),
  };
  const flightData = getSelectedFlightData(state);
  const { tour_id, flight_pair_id } = flightData?.back[0] || {
    tour_id: '',
    flight_pair_id: '',
  };

  const isFlightChangable = isChangableFlightSelector(state, {
    tour_id,
    flight_pair_id,
  });

  const hotelInfo = {
    location: getHotelLocation(state),
    name: getHotelName(state),
    stars: getHotelStars(state),
    image: getHotelImageSmall(state),
    meal: getMeal(state),
  };

  const additionalsInfo = {
    insurance: getIsInsurable(state),
    transfer: getTransfer(state),
    transferPrivate: getIsPrivateTransfer(state),
  };

  return {
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    flight: flightData || undefined,
    additionals: additionalsInfo,

    totalPrice: getRemainingPaymentAmount(state),
    instantConfirm: getInstantConfirm(state),
    cashbackAmount: orderOriginalTotalBonuses(state),
    packageId: getPackageId(state),
    priceDetailsItems: getPriceDetails(state),
    cashbackIdentifier:
      getOriginalPackageOrderBonuses(state)?.cashback_identifier || undefined,

    hotel: hotelInfo,
    touristsText: getTouristsText(state),
    isFlightChangable,

    client: getClientData(state) || undefined,

    tourists: touristsSelector(state),
    isTouristsConfirmed: getOrderTouristsConfirmed(state),

    visible: getShowSummary(state),

    isHotelOnly: false as const,
    dates: tourDates,
  };
};

const mapDispatchToPropsForTours = (dispatch) => ({
  onClose: () => dispatch(setShowSummaryAction(false)),
  onHotelClick: (packageId: number) => {
    dispatch(openRoomPopupAction(packageId));
  },
  onTouristClick: (touristNumber: number) => {
    dispatch(goToTouristsAction(touristNumber));
    dispatch(setShowSummaryAction(false));
  },
  onClientClick: () => {
    dispatch(goToClientAction());
    dispatch(setShowSummaryAction(false));
  },
  onFlightClick: () => {
    dispatch(goToFlightSectionAction());
    dispatch(setShowSummaryAction(false));
  },
});

const mapDispatchToPropsForHotels = (dispatch) => ({
  onClose: () => dispatch(setShowSummaryAction(false)),
  onHotelClick: (packageId: number) => {
    dispatch(openRoomPopupAction(packageId));
  },
  onTouristClick: (touristNumber: number) => {
    dispatch(onTouristClickAction(touristNumber));
    dispatch(setShowSummaryAction(false));
  },
  onClientClick: () => {
    dispatch(onClientClickAction());
    dispatch(setShowSummaryAction(false));
  },
});

const tourConnector = connect(
  mapStateToPropsForTours,
  mapDispatchToPropsForTours,
);

const hotelConnector = connect(
  mapStateToPropsForHotels,
  mapDispatchToPropsForHotels,
);

const MobileTourSummary = tourConnector(MobileSummaryTours);
const MobileHotelSummary = hotelConnector(MobileSummaryHotels);

export { MobileTourSummary, MobileHotelSummary };
